import React, { useState } from 'react';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import HeaderPages from '../../../../component/page-components/pages-header';
import FleetDetailDeliveryAssociate from './detail/DetailFleet';
import DriverProfileDeliveryAssociate from './detail/DriverProfile';
import { t } from 'i18next';
import useDetailDeliveryAssociate from './detail/detail-delivery-associate';
import DeleteConfirmationModal from '../../../../component/modal/DeleteConfirmationModal';
import style from './DeliveryAssociate.module.css'
import { ROUTES } from '../../../../constant/routeConstant';
import SuccessModal from "../../../../component/modal/SuccessModal";
import { ActiveDotIcon, BackIcon, CloseIcon, DAActiveIcon, DANonActiveIcon, InactiveDotIcon, InvitationExpiredIcon, InvitationSentIcon, OutsourceIcon, OwnedIcon } from '../../../../asset';
import { Timeline } from 'antd';

const DetailDeliveryAssociate = () => {
  const {
    tab1,
    tab2,
    _changeTab,
    _handleBack,
    _onDelete,
    _toEdit,
    data,
    driverProfile,
    fleetDetail,
    addtionalProofs,
    modalDeleteOpen,
    setModalDeleteOpen,
    doDeleteDA,
    navigate,
    successModalOpen,
    managementHistoryList,
    convertTimestamp,
    convertToTime
  } = useDetailDeliveryAssociate()

  const [userManagementOpen, setUserManagementOpen] = useState(false)

  return (
    <>
      <div className=' p-5 h-fit' >
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Master`}
          menuLevel2={`Fleet`}
          menuLevel3={`Add Delivery Associate`}
          menuLevel4={`Detail ${driverProfile?.first_name} - ${fleetDetail?.model}`}
        />
        {/* <HeaderPages
          title="Detail"
          delivery
          data={data}
          driver_name={`${driverProfile?.first_name}`}
          vehicle_type={`${fleetDetail?.model}`}
          handleBack={_handleBack}
        /> */}

        <div className='flex items-center justify-between my-[24px]'>
          <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => _handleBack()}>
            <img src={BackIcon} alt="" />
            <h1 className='font-sans-bold text-2xl' id='title'>{`${t("VEHICLE_DETAIL:TITLE")} ${driverProfile?.first_name} - ${fleetDetail.model}`}</h1>
            <img src={data?.driver_profile?.driver_type === "owned" ? OwnedIcon : OutsourceIcon} alt=""/>
            <img src={data.status ==="Invitation Expired" ? InvitationExpiredIcon : data.status ==="Invitation Sent" ? InvitationSentIcon : data.status === "Non-Active" ? DANonActiveIcon : data.status === "Active" ? DAActiveIcon : ""} alt="-"/>
      </div>

          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{data?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.updated_at, true)}</strong></p>
          </div>
        </div>

        <DeleteConfirmationModal
          isOpen={modalDeleteOpen}
          onOk={() => setModalDeleteOpen(false)}
          onCancel={() => doDeleteDA(data.delivery_associate_id, data.updated_at)}
          closable={false}
          width={440}
          className={style.modalContainer}
          okText="Cancel"
          cancelText="Yes, Delete"
          title="Delete Data?"
          description={<p>Are you sure want to delete <br /> <strong>{`${driverProfile?.first_name} ${driverProfile.last_name} - ${fleetDetail.vehicle_type}`}?</strong></p>}
        />

        <SuccessModal
          isOpen={successModalOpen}
          onOk={() => navigate(ROUTES.DELIVERY_ASSOCIATE.LIST)}
          closable={false}
          width={280}
          className={style.deleteModal}
          okText="Ok"
          title="Well Done"
          description="Your data has been deleted"
        />

        <div className=' bg-white-100 p-5 rounded-[10px]'>
          <div className=' flex flex-row'>
            <p
              className={
                tab1 ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer` :
                  `text-gray-100 font-roboto text-2xl font-medium cursor-pointer`
              }
              onClick={() => _changeTab(1)}
            >
              Driver Profile
            </p>
            <p
              className={
                tab2 ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-2` :
                  `text-gray-100 font-roboto text-2xl font-medium ml-2 cursor-pointer`
              }
              onClick={() => _changeTab(2)}
            >
              Fleet Detail
            </p>
          </div>
          {
            tab1 ? (
              <DriverProfileDeliveryAssociate data={driverProfile} />
            ) :
              tab2 ? (
                <FleetDetailDeliveryAssociate data={fleetDetail} additional_proofs={addtionalProofs} />
              ) : null
          }
        </div>
        <div className='flex flex-row-reverse gap-[16px] mt-4'>
          <PrimaryButton text={t("USER_DETAIL:EDIT")} action={_toEdit} />
          <SecondaryButton text={t("USER_DETAIL:DELETE")} action={_onDelete} />
        </div>

        <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
          <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
          <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data.created_at)}</strong></p>


          <div className={style.timelineContainer}>
            <Timeline>
              {
                managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  } else {
                    return (
                      <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  }
                })
              }
            </Timeline>
          </div>
        </aside>
      </div>
    </>
  );
}

export default DetailDeliveryAssociate;